const qcodes = [
  { code: "QRG", question: "What is my exact frequency?", statement: "Your exact frequency is... [in kHz]." },
  { code: "QRK", question: "What is the readability of my signals?", statement: "The readability of your signal is [R]." },
  { code: "QRL", question: "Are you busy?", statement: "I am busy." },
  { code: "QRM", question: "Are you being interfered with?", statement: "I am being interfered with." },
  { code: "QRN", question: "Are you troubled by static?", statement: "I am troubled by static." },
  { code: "QRO", question: "Should I increase power?", statement: "Increase power." },
  { code: "QRP", question: "Shall I decrease power?", statement: "Decrease power." },
  { code: "QRQ", question: "Shall I send faster?", statement: "Send faster [words/minute]." },
  { code: "QRS", question: "Shall I send more slowly?", statement: "Send more slowly [words/minute]." },
  { code: "QRT", question: "Shall I stop sending?", statement: "Stop sending." },
  { code: "QRU", question: "Have you anything for me?", statement: "I have nothing for you." },
  { code: "QRV", question: "Are you ready?", statement: "I am ready." },
  { code: "QRX", question: "When will you call me again?", statement: "I will call again at .... [UTC][kHz]." },
  { code: "QRZ", question: "Who is calling me?", statement: "You are being called by …[callsign]." },
  { code: "QSB", question: "Are my signals fading?", statement: "Your signals are fading." },
  { code: "QSL", question: "Can you acknowledge receipt?", statement: "I acknowledge receipt." },
  { code: "QSO", question: "Can you directly communicate with …?", statement: "I can contact … directly [callsign]." },
  { code: "QSP", question: "Will you relay (a message) to ... [callsign]?", statement: "I will relay to ... [callsign]." },
  { code: "QSY", question: "Shall I change frequency to ... [kHz]?", statement: "Change frequency to ... [kHz]." },
  { code: "QTH", question: "What is your location?", statement: "My location is ..." }
];

// Helper function to generate wrong answers for Q codes
const generateWrongCodes = (correctCode, allCodes, count = 3) => {
  const wrongCodes = allCodes
    .filter(code => code !== correctCode)
    .sort(() => Math.random() - 0.5)
    .slice(0, count);
  return wrongCodes;
};

// Helper function to generate wrong meanings
const generateWrongMeanings = (correctMeaning, allMeanings, count = 3) => {
  const wrongMeanings = allMeanings
    .filter(meaning => meaning !== correctMeaning)
    .sort(() => Math.random() - 0.5)
    .slice(0, count);
  return wrongMeanings;
};

// Generate quiz questions from Q codes data
const generateQCodesQuiz = () => {
  const allCodes = qcodes.map(q => q.code);
  const allQuestions = qcodes.map(q => q.question);
  const questions = [];
  let questionId = 1;

  // Generate two types of questions for each Q code
  qcodes.forEach((qcode, index) => {
    // Type 1: Given Q code, what does it mean?
    const wrongMeanings = generateWrongMeanings(qcode.question, allQuestions);
    const meaningOptions = [qcode.question, ...wrongMeanings].sort(() => Math.random() - 0.5);
    const correctMeaningIndex = meaningOptions.indexOf(qcode.question);
    
    questions.push({
      id: questionId++,
      question: `What does the Q code "${qcode.code}" mean?`,
      options: meaningOptions,
      correct: correctMeaningIndex,
      explanation: `${qcode.code} means "${qcode.question}" The response would be: "${qcode.statement}"`
    });

    // Type 2: Given meaning, what is the Q code?
    if (index % 2 === 0) { // Only create every other one to avoid too many questions
      const wrongCodes = generateWrongCodes(qcode.code, allCodes);
      const codeOptions = [qcode.code, ...wrongCodes].sort(() => Math.random() - 0.5);
      const correctCodeIndex = codeOptions.indexOf(qcode.code);
      
      questions.push({
        id: questionId++,
        question: `Which Q code is used to ask: "${qcode.question}"`,
        options: codeOptions,
        correct: correctCodeIndex,
        explanation: `${qcode.code} is used to ask "${qcode.question}" The response would be: "${qcode.statement}"`
      });
    }
  });

  // Shuffle questions
  return questions.sort(() => Math.random() - 0.5);
};

export const qCodesQuizData = {
  id: 'qcodes-quiz',
  title: 'Q Codes Quiz',
  subtitle: 'Master essential amateur radio Q codes',
  description: 'Test your knowledge of common Q codes used in amateur radio communication',
  questions: generateQCodesQuiz()
};

export default qCodesQuizData;